import {
  GetAllCustomerSitesInput,
  GetAllCustomerSitesResponseSchema,
  UpdateCustomerSites,
} from "shared";
import { axiosClient } from "utilz";
import {
  apiErrorHandler,
  generateUrlString,
  getQueryDataObject,
  validateApiResponse,
} from "utilz/helpers";

export const getAllCustomerSites = async ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection = "asc",
  filter,
  searchQuery,
  customerId,
}: GetAllCustomerSitesInput) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });

    const url = await generateUrlString({
      // baseUrl: `/fetch/sites/${customerId}`,
      baseUrl: `/v2/customers/${customerId}/sites`,
      data,
    });

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      const result = validateApiResponse({
        response: response,
        schema: GetAllCustomerSitesResponseSchema,
      });
      return result;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//add customer sites
export const addCustomerSites = async ({
  customerIdParams,
  data,
}: {
  customerIdParams: any;
  data: any;
}) => {
  try {
    // const url = `/create/site/${customerIdParams}`;
    const url = `/v2/customers/${customerIdParams}/sites`;
    const response = await axiosClient.post(url, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//update customer sites
export const updateCustomerSites = async ({
  siteId,
  customerId,
  data,
}: UpdateCustomerSites) => {
  try {
    const url = await generateUrlString({
      baseUrl: `/update/site/${siteId}`,
      data: {
        customer_id: customerId,
      },
    });
    const response = await axiosClient.patch(url, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteCustomerSites = async ({
  customerIdParams,
  siteIds,
}: {
  customerIdParams: any;
  siteIds: any;
}) => {
  try {
    const url = `/deactivate/site/${customerIdParams}`;
    const response = await axiosClient.patch(url, siteIds);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
